export default __webpack_public_path__ + "static/media/chat.6eba7521.jpeg";